export const PROJECT_STATUS_DRAFT = 1;
export const PROJECT_STATUS_AGREEMENT = 2;
export const PROJECT_STATUS_IN_WORK = 3;
export const PROJECT_STATUS_ACCEPTANCE = 4;
export const PROJECT_STATUS_CLOSED = 5;
